/* AURAFRI - lignes de panier fusionnees.

   Shopify scinde un meme article en plusieurs lignes selon les allocations de
   la remise "2 achetees, 1 offerte". Le Liquid les regroupe a l'affichage en
   une ligne payante et une ligne offerte : une ligne affichee couvre donc
   plusieurs lignes reelles. Ni l'index de ligne du theme, ni /cart/change.js
   avec un id de variante, ni /cart/update.js par variante ne savent viser un
   tel groupe (mesure : un panier de 4 est passe a 10, puis a 18).

   La seule voie fiable est /cart/update.js avec les CLES DE LIGNE : la quantite
   voulue va sur la premiere cle du groupe, les autres passent a zero, et
   Shopify recalcule la remise et re-scinde lui-meme.

   Le rafraichissement passe par l'API de rendu de sections, comme le fait le
   theme : pas de rechargement de page, donc pas de tiroir qui se ferme puis se
   rouvre. */
(function () {
  if (window.__aurafriCartMerge) return; // charge par la page panier ET par le tiroir
  window.__aurafriCartMerge = true;

  var TEXT_UPDATING = 'Mise à jour du panier…';
  var TEXT_FREE = 'Ton alarme offerte est ajoutée';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- voile de mise a jour ---------- */

  function styleOnce() {
    if (document.getElementById('aurafri-merge-style')) return;
    var css =
      '.aurafri-cart-veil{position:fixed;inset:0;z-index:2147483000;display:flex;' +
      'align-items:center;justify-content:center;background:rgba(255,255,255,.72);' +
      '-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);opacity:0;' +
      'transition:opacity .18s ease}' +
      '.aurafri-cart-veil[data-shown="1"]{opacity:1}' +
      '.aurafri-cart-veil__box{display:flex;align-items:center;gap:12px;padding:14px 20px;' +
      'background:#fff;box-shadow:0 6px 30px rgba(22,36,29,.18);color:#16241D;' +
      'font-weight:600;font-size:15px;max-width:80vw;text-align:left}' +
      '.aurafri-cart-veil__spin{width:18px;height:18px;flex:0 0 18px;border:2px solid rgba(31,92,69,.25);' +
      'border-top-color:#1F5C45;border-radius:50%;animation:aurafri-spin .7s linear infinite}' +
      '@keyframes aurafri-spin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){.aurafri-cart-veil{transition:none}' +
      '.aurafri-cart-veil__spin{animation-duration:2s}}';
    var tag = document.createElement('style');
    tag.id = 'aurafri-merge-style';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  var veil = null;

  function showVeil(message) {
    styleOnce();
    if (!veil) {
      veil = document.createElement('div');
      veil.className = 'aurafri-cart-veil';
      veil.setAttribute('role', 'status');
      veil.setAttribute('aria-live', 'polite');
      veil.innerHTML =
        '<div class="aurafri-cart-veil__box"><span class="aurafri-cart-veil__spin"></span>' +
        '<span class="aurafri-cart-veil__text"></span></div>';
      document.body.appendChild(veil);
    }
    veil.querySelector('.aurafri-cart-veil__text').textContent = message;
    requestAnimationFrame(function () {
      veil.setAttribute('data-shown', '1');
    });
  }

  function setVeilText(message) {
    if (veil) veil.querySelector('.aurafri-cart-veil__text').textContent = message;
  }

  function hideVeil() {
    if (!veil) return;
    veil.removeAttribute('data-shown');
    var node = veil;
    setTimeout(function () {
      if (node && node.parentNode) node.parentNode.removeChild(node);
      if (veil === node) veil = null;
    }, 200);
  }

  /* ---------- rafraichissement par sections ---------- */

  function sectionTargets() {
    var targets = [];
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id) {
      targets.push({ section: main.dataset.id, selector: '.js-contents', into: '#main-cart-items .js-contents' });
    }
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) {
      targets.push({ section: footer.dataset.id, selector: '.js-contents', into: '#main-cart-footer .js-contents' });
    }
    if (document.getElementById('CartDrawer')) {
      targets.push({ section: 'cart-drawer', selector: '.drawer__inner', into: '#CartDrawer .drawer__inner' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      targets.push({ section: 'cart-icon-bubble', selector: '.shopify-section', into: '#cart-icon-bubble' });
    }
    return targets;
  }

  function innerOf(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function refreshSections() {
    var targets = sectionTargets();
    if (!targets.length) return Promise.reject();
    var names = targets
      .map(function (t) { return t.section; })
      .filter(function (v, i, a) { return a.indexOf(v) === i; });

    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(names.join(',')))
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        targets.forEach(function (t) {
          var html = sections[t.section];
          var into = document.querySelector(t.into);
          if (!html || !into) return;
          var inner = innerOf(html, t.selector);
          if (inner !== null) into.innerHTML = inner;
        });
      });
  }

  /* ---------- mise a jour du panier ---------- */
    /* ---------- reveil des modules du panier ----------

     cart-modules.js et CartItems.updateQuantity attachent le compte a rebours et
     les carrousels au chargement, sur des elements precis. Remplacer le contenu
     du panier detache ces elements : le decompte continue en memoire sans plus
     s'afficher, et la bande marketing se fige.

     CartDrawer expose launchTimer(), launchTrustSlider() et launchUpsellSlider(),
     idempotentes : launchTimer() nettoie son intervalle avant d'en poser un
     nouveau, et c'est elle qui applique le reglage « reinitialiser le compte a
     rebours lorsqu'un nouveau produit est ajoute » (data-reset-on-add), en
     comparant le nombre d'articles a celui qu'elle a memorise. On l'appelle donc
     plutot que de la reecrire.

     La page panier n'a pas de <cart-drawer> : on y reprend la meme logique, avec
     les memes cles de stockage. Son module de timer ne porte pas l'attribut
     data-reset-on-add, donc il ne se reinitialise pas, exactement comme avant. */

  var TIMER_KEY = 'storyThemeDrawerTimer';
  var TIMER_INTERVAL_KEY = '__drawerTimerInterval__';
  var TIMER_COUNT_KEY = '__drawerCartItemCount__';

  function reviveSwiper(selector, options) {
    var el = document.querySelector(selector);
    if (!el || !window.Swiper || el.swiper) return;
    new window.Swiper(selector, options);
  }

  function relaunchTimerStandalone() {
    var module = document.querySelector('.drawer__module--timer');
    if (!module) return;
    var el = module.querySelector('.drawer__module--timer-time');
    if (!el) return;

    var duration = Number(module.dataset.duration);
    var resetOnAdd = module.dataset.resetOnAdd === 'true';

    if (window[TIMER_INTERVAL_KEY]) {
      clearInterval(window[TIMER_INTERVAL_KEY]);
      window[TIMER_INTERVAL_KEY] = null;
    }

    fetch(root() + 'cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var time = Number(localStorage.getItem(TIMER_KEY));
        var previous = Number(localStorage.getItem(TIMER_COUNT_KEY)) || 0;

        if (!cart.item_count) {
          localStorage.removeItem(TIMER_KEY);
          localStorage.removeItem(TIMER_COUNT_KEY);
          el.textContent = '';
          return;
        }
        if (resetOnAdd && cart.item_count > previous) {
          time = duration * 60;
          localStorage.setItem(TIMER_KEY, time);
        }
        if (!time || time <= 0) {
          time = duration * 60;
          localStorage.setItem(TIMER_KEY, time);
        }
        localStorage.setItem(TIMER_COUNT_KEY, cart.item_count);

        var tick = function () {
          el.textContent = Math.floor(time / 60) + ':' + String(time % 60).padStart(2, '0');
          if (time > 0) {
            time--;
            localStorage.setItem(TIMER_KEY, time);
            return;
          }
          clearInterval(window[TIMER_INTERVAL_KEY]);
          window[TIMER_INTERVAL_KEY] = null;
          localStorage.removeItem(TIMER_KEY);
          localStorage.removeItem(TIMER_COUNT_KEY);
          0 && fetch(root() + 'cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          }).then(function () { window.location.reload(); });
        };

        tick();
        window[TIMER_INTERVAL_KEY] = setInterval(tick, 1000);
      })
      .catch(function () {});
  }

  function reviveCartModules() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.launchTimer === 'function') {
      drawer.launchTimer();
      if (typeof drawer.launchTrustSlider === 'function') drawer.launchTrustSlider();
      if (typeof drawer.launchUpsellSlider === 'function') drawer.launchUpsellSlider();
      return;
    }
    relaunchTimerStandalone();
    reviveSwiper('#drawer-trust__swiper', { autoplay: { delay: 2000 }, speed: 600, loop: true });
    reviveSwiper('#cart-upsell__swiper', { slidesPerView: 1.2, spaceBetween: 10, autoHeight: true });
  }

  /* le theme signale le panier vide par une classe sur ses propres composants ;
     comme on rafraichit les sections nous-memes, personne ne la poserait */
  function setEmptyState(isEmpty) {
    ['cart-items', 'cart-drawer-items', 'cart-drawer'].forEach(function (tag) {
      Array.prototype.forEach.call(document.querySelectorAll(tag), function (el) {
        el.classList.toggle('is-empty', isEmpty);
      });
    });
  }

  function freeCount(cart) {
    return (cart.items || []).reduce(function (n, item) {
      return item.final_line_price === 0 ? n + item.quantity : n;
    }, 0);
  }

  function send(input, newTotal) {
    var keys = (input.dataset.mergedKeys || '').split(',').filter(Boolean);
    if (!keys.length) return false;

    var freeBefore = parseInt(input.dataset.mergedFree || '0', 10);
    var updates = {};
    keys.forEach(function (key, i) {
      updates[key] = i === 0 ? newTotal : 0;
    });

    showVeil(TEXT_UPDATING);

    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var empty = cart.item_count === 0;

        /* Panier vide depuis la PAGE panier : son etat vide remplace toute la
           section, on rend la main au theme. Depuis le TIROIR au contraire, on
           reste sur place : le tiroir a son propre bloc vide, il suffit de le
           rendre et de poser la classe que le theme poserait. */
        if (empty && document.getElementById('main-cart-items')) {
          window.location.assign(root() + 'cart');
          return new Promise(function () {});
        }

        var gained = freeCount(cart) > freeBefore;
        if (gained) setVeilText(TEXT_FREE);
        return refreshSections().then(function () {
          setEmptyState(empty);
          reviveCartModules();
          return new Promise(function (done) { setTimeout(done, gained ? 650 : 0); });
        });
      })
      .then(hideVeil)
      .catch(function () {
        window.location.reload();
      });

    return true;
  }

  function lineInput(el) {
    var row = el.closest('.cart-item') || el.closest('tr');
    return row ? row.querySelector('input[data-merged-keys]') : null;
  }

  /* changement de quantite : delta applique au total de la variante,
     plafonne au stock quand l'inventaire est suivi et la survente refusee */
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('input[data-merged-keys]')) return;

      var oldValue = parseInt(input.getAttribute('value'), 10);
      var newValue = parseInt(input.value, 10);
      var total = parseInt(input.dataset.cartQuantity, 10);
      if (isNaN(oldValue) || isNaN(newValue) || isNaN(total)) return;

      event.stopPropagation();
      event.preventDefault();

      var newTotal = total + (newValue - oldValue);
      var max = parseInt(input.dataset.mergedMax || '0', 10);
      if (max > 0 && newTotal > max) {
        newTotal = max;
        input.value = Math.max(0, newValue - (total + (newValue - oldValue) - max));
      }
      if (newTotal < 0) newTotal = 0;
      if (newTotal === total) return;

      send(input, newTotal);
    },
    true
  );

  /* suppression : l'index de ligne du theme ne designerait qu'une des lignes reelles */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('cart-remove-button');
      if (!button) return;
      var input = lineInput(button);
      if (!input) return;
      event.stopPropagation();
      event.preventDefault();
      send(input, 0);
    },
    true
  );
})();
